import { api } from './api';
import { RemittanceFile, RemittanceFilter, RemittanceFileListResponse } from '../types/remittance';
import { OutwardRemittanceFile } from '../types/remittance';

export const remittanceService = {
  async getRemittanceFiles(params: RemittanceFilter): Promise<RemittanceFileListResponse> {
    const { data } = await api.get<RemittanceFileListResponse>('/remittance/file-data', {
      params,
    });
    return data;
  },

  async uploadInwardRemittance(formData: FormData): Promise<any> {
    const { data } = await api.post('/remittance/upload-inward', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },

  async uploadOutwardRemittance(formData: FormData): Promise<any> {
    const { data } = await api.post('/remittance/upload-outward', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },

  async getExportUpcomingData(userId: number): Promise<Blob> {
    const { data } = await api.get(`/remittance/export-upcoming/${userId}`, {
      responseType: 'blob',
    });
    return data;
  },

  async getExportProcessMasterData(userId: number): Promise<Blob> {
    const { data } = await api.get(`/remittance/export-process-master/${userId}`, {
      responseType: 'blob',
    });
    return data;
  },

  async getRemittanceList(
    userId: number | string, 
    params: { page?: number; size?: number; search?: string; status?: string; fromDate?: string; toDate?: string }
  ): Promise<any> {
    const { data } = await api.get(`/remittance/list/${userId}`, { params });
    return data;
  },

  async getRemittanceDetail(userId: number | string, remittanceId: string, params: { searchTracking?: string }): Promise<any> {
    const { data } = await api.get(`/remittance/detail/${userId}/${remittanceId}`, { params });
    return data;
  },

  async getExportLedgersData(
    userId: number | string,
    params: { ledgerNumbers?: string[]; search?: string; status?: string; fromDate?: string; toDate?: string }
  ): Promise<Blob> {
    const { data } = await api.get(`/remittance/export-ledgers/${userId}`, {
      params,
      responseType: 'blob',
    });
    return data;
  },

  async getExportLedgerDetailData(
    userId: number | string,
    ledgerNumber: string,
    params: { searchTracking?: string }
  ): Promise<Blob> {
    const { data } = await api.get(`/remittance/export-detail/${userId}/${ledgerNumber}`, {
      params,
      responseType: 'blob',
    });
    return data;
  },

  async getExportMultipleLedgersZip(
    userId: number | string,
    ledgerNumbers: string[]
  ): Promise<Blob> {
    const params = new URLSearchParams();
    ledgerNumbers.forEach((ledgerNumber) => params.append('ledgerNumbers', ledgerNumber));
    const { data } = await api.get(`/remittance/export-ledgers-zip/${userId}`, {
      params,
      responseType: 'blob',
    });
    return data;
  },
};
